import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { createBrowserHistory as createHistory } from 'history'
import reducers from './reducers'
import { authenticate } from './middlewares'
import { loginRedirect as login } from 'redux/authenticate/actions'

let middleware = []
if (process.env.NODE_ENV !== 'production') {
  const createLogger = require('redux-logger').createLogger
  middleware = [
    createLogger({
      collapsed: true
    })
  ]
}

const history = createHistory()
const authenticateMiddleware = authenticate({ login })

const configureStore = initialState => {
  return createStore(
    reducers,
    initialState,
    applyMiddleware(thunkMiddleware, authenticateMiddleware, ...middleware)
  )
}

export { configureStore as default, history }
